import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { usePlacesWidget } from 'react-google-autocomplete';
import TextField from '../TextField/TextField';
import styles from './CustomGoogleAutoComplete.module.scss';
import clsx from 'clsx';
function CustomGoogleAutoComplete({
  field,
  form,
  className,
  label,
  width = '100%',
  inputWidth = '100%',
  labeledTag,
  margin = '0 0 10px 0',
  type = 'text',
  inputColor = '#F4F4F4',
  inputDisabledColor = '#F4F4F4',
  borderRadius = '8px',
  border = 'none',
  textarea = false,
  checkBoxAsRadio = false,
  height = '52px',
  showPassword = false,
  iconComponent,
    ...props}
) {
  const [inputType, setInputType] = useState(type);
  const { touched, errors,setFieldValue } = form || {};
  const isError = touched && errors
    ? field?.name.split('.').reduce(
      (acc, item) => (acc.errors[item] && acc.touched[item]
        ? {
          errors: acc.errors[item],
          touched: acc.touched[item],
          errorText: acc.errors[item],
        }
        : {
          errors,
          touched,
          errorText: {},
        }),
      { errors, touched, errorText: {}},
    )
    : '';

  useEffect(() => {
    setInputType(type);
  }, [type]);

  function changeAddress(place) {
    const lat = place?.geometry?.location?.lat();
    const lng = place?.geometry?.location?.lng();
    const {address_components} = place;
    const address = address_components.reduce((acc,curr)=> {
      acc[curr.types[0]] = curr.long_name;
      return acc;
    },{})
    const postalCode = address.postal_code;
    const streetNumber = address.street_number;
    const city = address.locality || address.administrative_area_level_3;
    const province = address.administrative_area_level_2;
    const region = address.administrative_area_level_1;
    const country = address.country;
    const street = address.route;
    const fieldName = field.name;
    form.setFieldValue(fieldName, {
      country,
      region,
      province,
      city,
      streetNumber,
      postalCode,
      street,
      lat,
      lng,
      address: place.formatted_address,
    });
  }

  const googleApiKey = 'AIzaSyDzLkBY6l1c0atoxCLVV0uB5KTDgnGewng';

  const { ref } = usePlacesWidget({
    apiKey: googleApiKey,
    onPlaceSelected: (place) => {
      changeAddress(place);
    },
    options: {
      types: ['geocode', 'establishment'],
    },
  });

  return (
    <div
      className={clsx(styles.field__wrapper, styles[`${className}`], {
        [styles['full-height']]: textarea && height === '100%',
      })}
      style={{ margin, width, opacity: props.disabled ? 0.4 : 1 }}
    >
      {label && !checkBoxAsRadio ? (
        <label className={styles.field__label} htmlFor={field?.name}>
          {label}
        </label>
      ) : (
        labeledTag
      )}
    <div
          className={  clsx(styles['input-group'], { [styles['error-field']]: !!isError.errorText })}
          style={{
            borderRadius,
            height,
            border,
            width: inputWidth,
            background: `${props.disabled ? inputDisabledColor : inputColor}`,
          }}
        >
          <input
            className={styles.field__input}
            type={inputType}
            autoComplete="new-password"
            {...props}
            style={{
              background: `${props.disabled ? inputDisabledColor : inputColor}`,
            }}
            ref={ref}
          />
          {iconComponent}
        </div>
      {!!isError.errorText && <div className={styles.error}>{
     Object.values(isError.errorText)[0]
      }</div>}
    </div>
  );
}

export default CustomGoogleAutoComplete;
